import { Dayjs } from 'dayjs';
import { pipe } from 'effect';

import { ScanTypeDetails } from '../../services/scan-types/schemas';
import { AdminUser, SiteAdminUser } from '../../types/User';
import { ScanTypeDetailsFormData } from './ScanTypeDetails';

const formatISODate = (date: Dayjs) => date.format('YYYY-MM-DDTHH:mm');

export const getDefaultFormValues = (data: ScanTypeDetails) =>
    ({
        name: data.name,
        groupType: data.groupType,
        allowFailedChecks: data.allowFailedChecks,
        boxType: data.boxType,
        description: data.description,
        isProtected: data.isProtected,
        status: data.status,
        createdTime: pipe(data.createdTime, formatISODate),
        createdByUsername: data.createdByUsername
    }) satisfies ScanTypeDetailsFormData;

const EDITABLE_FIELD_KEYS = new Set<keyof ScanTypeDetailsFormData>([
    'name',
    'groupType',
    'status',
    'boxType',
    'allowFailedChecks',
    'isProtected',
    'description'
]);

export const createPayload = (
    data: ScanTypeDetailsFormData,
    dirtyFieldKeys: string[]
): Partial<ScanTypeDetailsFormData> => {
    const fieldKeysToUpdate = dirtyFieldKeys.filter((key): key is keyof ScanTypeDetailsFormData =>
        EDITABLE_FIELD_KEYS.has(key as keyof ScanTypeDetailsFormData)
    );

    const fieldsToUpdate = fieldKeysToUpdate.reduce<Partial<ScanTypeDetailsFormData>>(
        (acc, key) => ({
            ...acc,
            [key]: data[key]
        }),
        {}
    );

    return fieldsToUpdate;
};

export const canEditForm = (isProtected: boolean, userType: (AdminUser | SiteAdminUser)['type']): boolean => {
    if (userType === 'ADMIN') return true;

    return !isProtected;
};

export const getAriaProps = (index: number) => ({
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`
});
